// src/Delivery.js
import React from 'react';
import { useLanguage } from './LanguageContext';
import './Delivery.css'; // Подключаем стили для этого компонента

// Импортируем все необходимые изображения
import truckIcon from './assets/delivery-truck-icon.png';
import pinIcon from './assets/location-pin-icon.png';
import mapImage from './assets/kazakhstan-map.png';

const Delivery = () => {
  const { t } = useLanguage();

  return (
    <section className="delivery-section">
      <div className="delivery-title-wrapper">
        <h2 className="delivery-main-title">{t('delivery')}</h2>
      </div>
      <div className="delivery-content">
        <div className="delivery-info">
          <h3 className="delivery-headline">
            {t('freeDeliveryKazakhstan')}
          </h3>
          <div className="delivery-option">
            <img src={truckIcon} alt={t('deliveryAlmaty')} />
            <div className="delivery-option-text">
              <h4>{t('deliveryAlmaty')}</h4>
              <p>{t('deliveryAlmatyDesc')}</p>
            </div>
          </div>
          <div className="delivery-option">
            <img src={pinIcon} alt={t('deliveryOtherCities')} />
            <div className="delivery-option-text">
              <h4>{t('deliveryOtherCities')}</h4>
              <p>{t('deliveryOtherCitiesDesc')}</p>
            </div>
          </div>
        </div>
        <div className="delivery-map">
          <img src={mapImage} alt="Карта доставки по Казахстану" />
          
        </div>
      </div>
    </section>
  );
};

export default Delivery;